import axios from "axios";

/**
 * Extrai uma mensagem legível de erro a partir de uma falha de requisição.
 *
 * Prioriza o campo `detail` retornado pelo backend (FastAPI). Quando não há
 * resposta (falha de rede), retorna uma mensagem de indisponibilidade. Como
 * último recurso, usa `error.message` ou um texto genérico.
 */
export const getApiErrorMessage = (error: unknown): string => {
  if (axios.isAxiosError<{ detail?: string }>(error)) {
    const detail = error.response?.data?.detail;
    if (detail) return detail;
    if (!error.response) return "Serviço temporariamente indisponível.";
  }

  if (error instanceof Error && error.message) return error.message;
  return "Não foi possível concluir a operação.";
};
